import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function Stock() {
  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({ product_id: "", on_hand: 0, reserved: 0, location: "", packaging: "çuval", lead_time_days: 7 });

  const load = async () => {
    const [s, p] = await Promise.all([api.get("/stock"), api.get("/products")]);
    setItems(s.data); setProducts(p.data);
  };
  useEffect(() => { load(); }, []);

  const upsert = async () => {
    const prod = products.find(p => p.id === form.product_id);
    if (!prod) return toast.error("Ürün seçin");
    await api.post("/stock", { ...form, product_code: prod.code, product_name: prod.name });
    toast.success("Kaydedildi");
    load();
  };

  return (
    <div className="space-y-6" data-testid="stock-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Depo</div>
        <h2 className="font-heading text-3xl font-bold tracking-tight mt-1">Stok ve Teslimat</h2>
      </div>

      <Card className="p-5 border-border">
        <h3 className="font-heading font-semibold mb-3">Stok Güncelle</h3>
        <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
          <Select value={form.product_id} onValueChange={(v) => setForm({ ...form, product_id: v })}>
            <SelectTrigger data-testid="stock-product"><SelectValue placeholder="Ürün" /></SelectTrigger>
            <SelectContent>{products.map(p => <SelectItem key={p.id} value={p.id}>{p.code} — {p.name}</SelectItem>)}</SelectContent>
          </Select>
          <Input type="number" placeholder="Mevcut" value={form.on_hand} onChange={(e) => setForm({ ...form, on_hand: Number(e.target.value) })} />
          <Input type="number" placeholder="Ayrılan" value={form.reserved} onChange={(e) => setForm({ ...form, reserved: Number(e.target.value) })} />
          <Input placeholder="Depo" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />
          <Input placeholder="Paketleme" value={form.packaging} onChange={(e) => setForm({ ...form, packaging: e.target.value })} />
          <Button data-testid="save-stock" onClick={upsert} className="bg-primary hover:bg-orange-600 text-white">Kaydet</Button>
        </div>
      </Card>

      <Card className="border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900 text-white text-left"><tr>{["Kod", "Ürün", "Mevcut", "Ayrılan", "Kullanılabilir", "Depo", "Paket", "Tedarik (gün)"].map(h => <th key={h} className="px-4 py-2 font-semibold">{h}</th>)}</tr></thead>
            <tbody>
              {items.map(s => (
                <tr key={s.id} className="border-t border-border hover:bg-slate-50">
                  <td className="px-4 py-2 font-mono">{s.product_code}</td>
                  <td className="px-4 py-2">{s.product_name}</td>
                  <td className="px-4 py-2 num">{s.on_hand}</td>
                  <td className="px-4 py-2 num">{s.reserved}</td>
                  <td className="px-4 py-2 num font-bold">{(s.on_hand || 0) - (s.reserved || 0)}</td>
                  <td className="px-4 py-2">{s.location}</td>
                  <td className="px-4 py-2">{s.packaging}</td>
                  <td className="px-4 py-2">{s.lead_time_days}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={8} className="px-4 py-8 text-center text-muted-foreground">Henüz stok kaydı yok.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
